import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { toast } from 'react-toastify';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { goRiceUrl } from '../../../../constant/siteConstants';
import getConfigToken from '../../../../utils/getConfigToken';
import useFormatMessage from '../../../../utils/useFormatMessage';
import PermissionTab from '../common/PermissionTab';

export default function PermissionModal({ modalPermission, setModalPermission }) {
    const notifySuccess = (message) => toast.success(`${message}`);
    const notifyError = (message) => toast.error(`${message}`);
    const [permissionGroupDatas, setPermissionGroupDatas] = useState([]);
    const [selectedPermissionGroup, setSelectedPermissionGroup] = useState();
    const [roleGroups, setRoleGroups] = useState([]);
    const [userDatas, setUserDatas] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedUsers, setSelectedUsers] = useState([]);

    const { t } = useFormatMessage();

    async function getRoleGroups() {
        await Axios.post(`${goRiceUrl}/api/employee/getAllRolesAndRoleGroup`, {}, getConfigToken).then((resp) => {

            resp.data.forEach(obj => {

                obj.checked = false

            })
            setRoleGroups(resp.data);

        }).catch((err) => {
            console.error(err);
            notifyError("Rol Grupları yüklenirken bir servis hatası meydana geldi.");
        })
    }

    async function getPermissionGroups() {
        await Axios.post(`${goRiceUrl}/api/employee/getPermissionGroupsWithRoles`, {}, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                setPermissionGroupDatas(resp.data);
            } else {
                notifyError("Yetki Grupları yüklenirken bir hata meydana geldi.");
            }
        }).catch((err) => {
            console.error(err);
            notifyError("Yetki Grupları yüklenirken bir servis hatası meydana geldi.");
        })
    }

    async function getUserDatas() {
        await Axios.post(`${goRiceUrl}/api/employee/getAll`, {}, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                setUserDatas(resp.data)
            } else {
                notifyError("Kullanıcı bilgileri yüklenirken bir hata meydana geldi.");
            }
        }).catch((err) => {
            console.error(err);
            notifyError("Kullanıcı bilgileri yüklenirken bir servis hatası meydana geldi.");
        })
    }

    async function configureUserRoles() {
        await Axios.post(`${goRiceUrl}/api/employee/updateRoles`, {
            "employee_id": selectedUsers,
            "permission_group_ids": selectedPermissionGroup,
            "special_role_ids": selectedPermissionGroup,
            "user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))

        }, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                setModalPermission(false);
                notifySuccess("Kullanıcı Yetki Grubu Ataması başarıyla gerçekleşti.")
            } else {
                notifyError("Yetki Grubu eklenirken bir hata meydana geldi.");
            }
        }).catch((err) => {
            console.error(err);
            notifyError("Yetki Grubu eklenirken bir servis hatası meydana geldi.");
        })
    }

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (modalPermission === true) {
            getRoleGroups();
            getPermissionGroups();
            getUserDatas();
        }
    }, [modalPermission])
    /* eslint-disable react-hooks/exhaustive-deps */


    return (
        <Modal size="lg" isOpen={modalPermission} toggle={() => { setModalPermission(!modalPermission); }}>
            <ModalHeader toggle={() => { setModalPermission(!modalPermission); }}>
                {t("Kullanıcı Yetki Grubu Atama Formu")}
            </ModalHeader>
            <ModalBody>
                <PermissionTab selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys} roleGroups={roleGroups} permissionGroupDatas={permissionGroupDatas} selectedPermissionGroup={selectedPermissionGroup} setSelectedPermissionGroup={setSelectedPermissionGroup} selectedUsers={selectedUsers} setSelectedUsers={setSelectedUsers} userDatas={userDatas} isPermissionModal={true} />
            </ModalBody>
            <ModalFooter>
                <Col lg="12" className='d-flex justify-content-between align-items-center' >
                    <Button id='saveButtonNew' disabled={false} onClick={() => { configureUserRoles(); document.getElementById("saveButtonNew").disabled = true }} >{t("Kaydet")}</Button>
                    <Button id='cancelButtonNew' color='danger' onClick={() => { setModalPermission(false) }} >{t("İptal")}</Button>
                </Col>
            </ModalFooter>
        </Modal>
    )
}